export default __webpack_public_path__ + "static/media/logo_VLX_small.b945e697.svg";